import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import apiService from '../services/apiservices'
import { storesTableReady,storeAddEditTimingReady} from '../redux/stores'


//import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/storeTable.css'


import * as Helpers from '../../../common/helpers'


import TimePicker from 'react-time-picker'

class CollapsibleRow extends Component {
    constructor() {
        super()
        this.state = {
            updatedTimingArr:[],
            clearIcon:null
        }
        this.dialog = null
    }

    componentWillMount() {
        this.setState({
            updatedTimingArr:this.props.row.store_timings
        });
    }


    loadPage=(flag)=>{
        if(window.location.pathname==="/dashboard/stores/list"){
            this.props.dispatch(storesTableReady(flag))
        }else{
             this.props.dispatch(storeAddEditTimingReady(flag))
        }

    };


    updateTiming= (row) =>{

        this.loadPage(false);
        

        let selectArr={};

        let updatedTimingArr=this.state.updatedTimingArr;

        updatedTimingArr.map(function(item) {
            if(item.store_timings_id===row.store_timings_id){
                selectArr=item;
            } 
            return true
        })


        if(selectArr.start_time==='' || selectArr.start_time===undefined || selectArr.start_time===null){
           this.loadPage(true);
            this.dialog.show({
                            title: "Error!!",
                            body: "Please provide start time in 24 hours format",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
            return false
        }

        if(selectArr.end_time==='' || selectArr.end_time===undefined || selectArr.end_time===null){
            this.loadPage(true);
            this.dialog.show({
                            title: "Error!!",
                            body: "Please provide end time in 24 hours format",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
            return false
        }

        if(parseInt(selectArr.start_time.split(":").join(""),10)<0 || parseInt(selectArr.start_time.split(":").join(""),10)>=2400){
           this.loadPage(true);
            this.dialog.show({
                            title: "Error!!",
                            body: "Start time should fall  in between 00 to 23 Hrs",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
            return false
        }

        if(parseInt(selectArr.end_time.split(":").join(""),10)<0 || parseInt(selectArr.end_time.split(":").join(""),10)>=2400){
            this.loadPage(true);
            this.dialog.show({
                            title: "Error!!",
                            body: "End time should fall  in between 00 to 23 Hrs",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
            return false
        }


        if(parseInt(selectArr.end_time.split(":").join(""),10)-parseInt(selectArr.start_time.split(":").join(""),10)<60 && !selectArr.end_day){
             this.loadPage(true);

            this.dialog.show({
                            title: "Error!!",
                            body: "Start and end time should have minimum 1 hour range",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
            return false
        }

         let enday="CURRENT_DAY"

        if(selectArr.end_day){
            enday="NEXT_DAY"
        }
        
        let apiPayloadData={
                "start_time": selectArr.start_time,
                "end_time": selectArr.end_time,
                "end_day":enday
            }


        this.checkOverLapTiming(apiPayloadData,row.store_timings_id,row.store_id)

        

    }


    overLappingMsg=(overLappingTimes)=>{

           this.loadPage(true);
                        this.dialog.show({
                            title: "Error!!",
                            body: "Given time is overlapping with existing time slots ( "+overLappingTimes+" ). Please check and use other time range",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
    }



    callAPICall=(apiPayloadData,store_timings_id)=>{

           apiService.updateStoreTiming(apiPayloadData,store_timings_id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.loadPage(true);
                        window.location.reload();
                    } else {

                        this.loadPage(true);
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.loadPage(true);
                console.error("Error data: ", err)
               alert("exception"+ err);
            })

    }

     checkOverLapTiming=(apiPayloadData,store_timings_id,store_id)=>{

        let startime=parseInt(apiPayloadData.start_time.split(":").join(""),10)
        let endtime=parseInt(apiPayloadData.end_time.split(":").join(""),10)

        
        apiService.getStoreDetailsById(store_id)
            .then(responseData => {
                    let store_timings=responseData.data.store_timings;
                    if(store_timings.length===0){
                        this.callAPICall(apiPayloadData,store_timings_id)
                    }else{
                        let overLappingflag=false;
                        let overLappingTimes="";
                        for (var i = store_timings.length - 1; i >= 0; i--) {

                            if(store_timings[i].id!==store_timings_id){
                                let api_start_time=parseInt(store_timings[i]['start_time'].split(":").join(""),10)
                                let api_end_time=parseInt(store_timings[i]['end_time'].split(":").join(""),10)
                                let end_day=store_timings[i]['end_day']

                                if(end_day==="CURRENT_DAY" && apiPayloadData.end_day==="CURRENT_DAY"){

                                    if((startime>=api_start_time && startime<=api_end_time) || (endtime>=api_start_time && endtime<=api_end_time)){
                                        overLappingflag=true;
                                        overLappingTimes=overLappingTimes+api_start_time+" to "+api_end_time+"; ";
                                    }

                                }else if(end_day==="NEXT_DAY" && apiPayloadData.end_day==="CURRENT_DAY"){

                                    if((startime>=api_start_time && startime<=2359) || (endtime>=api_start_time && endtime<=2359) || (startime>=0 && startime<=api_end_time) || (endtime>=0 && endtime<=api_end_time)){
                                        overLappingflag=true;
                                        overLappingTimes=overLappingTimes+api_start_time+" to "+api_end_time+"; ";
                                    }

                                }else if(end_day==="CURRENT_DAY" && apiPayloadData.end_day==="NEXT_DAY"){

                                    if((startime<=api_start_time && 2359>=api_start_time) || (startime<=api_end_time && 2359>=api_end_time) || (0<=api_start_time && 0>=api_start_time) || (endtime<=api_end_time && endtime>=api_end_time)){
                                        overLappingflag=true;
                                        overLappingTimes=overLappingTimes+api_start_time+" to "+api_end_time+"; ";
                                    }

                                }else if(end_day==="NEXT_DAY" && apiPayloadData.end_day==="NEXT_DAY"){

                                    if((startime>=api_start_time && startime<=2359) || (endtime>=api_start_time && endtime<=2359) || (startime>=0 && startime<=api_end_time) || (endtime>=0 && endtime<=api_end_time) || (startime<=api_start_time && 2359>=api_start_time) || (startime<=api_end_time && 2359>=api_end_time) || (0<=api_start_time && 0>=api_start_time) || (endtime<=api_end_time && endtime>=api_end_time)){
                                        overLappingflag=true;
                                        overLappingTimes=overLappingTimes+api_start_time+" to "+api_end_time+"; ";
                                    }

                                    }
                                }
                            }
                            if(overLappingflag){
                                this.overLappingMsg(overLappingTimes)
                            }else{
                                this.callAPICall(apiPayloadData,store_timings_id);
                            }
                        }
            })
            .catch(err => {
                this.loadPage(true);
                console.error("Error data: ", err)
                alert("exception"+ err);
            })
    }




    deleteTiming = (row) =>{
        
        if (window.confirm("Are you sure?") === true) {
            this.loadPage(false);
             apiService.deleteStoreTiming(row.store_timings_id)
            .then(responseData => {                 
                    if (responseData.status === "SUCCESS") {
                        this.loadPage(true);
                        window.location.reload();                        
                    } else {

                        this.loadPage(true);
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.loadPage(true);
                console.error("Error data: ", err)
               alert("exception"+ err);
            })
        
        } 
    }



    actionCreator = (cell, row, enumObject, rowIndex) => {
        //debugger;
        
        let updateBtn=""
        let deleteBtn=""


    if(Helpers.checkPrivileges("/dashboard/stores/addEditTiming",this.props.user)){

        updateBtn=<button
            className="action-button"
            style={{marginBottom: "1px" }}
            onClick={(e) => {
                e.preventDefault()
                this.updateTiming(row)
            }}>
            <i className="fa fa-pencil-square-o" aria-hidden="true"></i> Update
        </button>
        
        deleteBtn=<button
            className="action-button"
            style={{marginBottom: "1px",background: "red",color:"white"}}
            onClick={(e) => {
                e.preventDefault()
                this.deleteTiming(row)
            }}>
            <i className="fa fa-trash" aria-hidden="true"></i> Delete
        </button>
    }
         
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{updateBtn}   {deleteBtn} </div>
        </div>)
    }

    addStartTimePicker = (cell, row, enumObject, rowIndex) => {
    
    let temp=<TimePicker clearIcon={this.state.clearIcon} format="H:mm"  onChange={(value, e) => this.startTimeChange(value, e ,row.store_timings_id)}
       value={row.start_time} className="react-time-picker" disableClock="false"/>

       return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{temp} </div>
        </div>)
   }

   endStartTimePicker = (cell, row, enumObject, rowIndex) => {
    
    let temp=<TimePicker clearIcon={this.state.clearIcon} format="H:mm"  onChange={(value, e) => this.endTimeChange(value, e ,row.store_timings_id)}
       value={row.end_time} className="react-time-picker" disableClock="false"/>

       return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{temp} </div>
        </div>)
   }

   checkBoxChangeUpdate = (row,e,rowIndex) => {

        let storeData=this.props.row.store_timings.slice();
           
             storeData.map(function(item) {
                if(item.store_timings_id===row.store_timings_id){
                    item['end_day']=e.target.checked
                    return true;
                }
                return true;
            });

             this.setState({
                storeData:storeData
             })
        }


    renderCheckBox = (cell, row, enumObject, rowIndex) => {
        //debugger;

        let checkBox=<input className="checkbox form-check-input" type="checkbox" value={row.store_timings_id} onChange={(e) => {
                     this.checkBoxChangeUpdate(row,e,rowIndex)
                }} checked={row.end_day}/>
        
        
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
                  {checkBox}
            </div>
        </div>)
    }


   

   startTimeChange=(value,e,store_timings_id) =>{

    let existingFlag=false;
    let updatedTimingArr=this.state.updatedTimingArr;

    let propsArr=this.props.row.store_timings

    let end_time="";

    let end_day="";

         propsArr.map(function(item) {
                if(item.store_timings_id===store_timings_id){
                    end_time=item.end_time
                    end_day=item.end_day
                } 
                return true
            })

    updatedTimingArr.map(function(item) {
            if(item.store_timings_id===store_timings_id){
                item.start_time=value
                existingFlag=true
            } 
            return true
        })

    if(!existingFlag){
        updatedTimingArr.push({
            "store_timings_id":store_timings_id,
            "start_time":value,
            "end_time":end_time,
            "end_day":end_day
        })
    }

     this.setState({
         updatedTimingArr: updatedTimingArr
     });
   }

   endTimeChange=(value,e,store_timings_id) =>{
        let existingFlag=false;
        let updatedTimingArr=this.state.updatedTimingArr;

        let propsArr=this.props.row.store_timings

        let start_time="";
        let end_day="";

            propsArr.map(function(item) {
                if(item.store_timings_id===store_timings_id){
                    start_time=item.start_time
                    end_day=item.end_day
                } 
                return true
            })


        updatedTimingArr.map(function(item) {
                if(item.store_timings_id===store_timings_id){
                    item.end_time=value
                    existingFlag=true
                } 
                return true
            })

        if(!existingFlag){
            updatedTimingArr.push({
                "store_timings_id":store_timings_id,
                "start_time":start_time,
                "end_time":value,
                "end_day":end_day
            })
        }

         this.setState({
             updatedTimingArr: updatedTimingArr
         });
   }
   

    

    

    render() {
        const options = {
            page: 1,  // which page you want to show as default
            sizePerPage: 10,  // which size per page you want to locate as default
        }
        return (
            <div style={{ backgroundColor: "#e1e5ed",margin: "0% 4%" }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    className="table-border"
                    options={options}
                    data={this.props.row.store_timings}
                    hover={false}
                    headerStyle={{ border: '0px', color: '#000' }}
                    tableStyle={{ border: '0px' }}
                    bodyStyle={{ border: '0px', overflow: "auto",tableLayout:"auto" }}>



                      {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="store_timings_id"
                                            
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="store_timings_id"
                                            
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}

                    <TableHeaderColumn
                        //dataField="start_time"
                         dataFormat={this.addStartTimePicker}
                        className="table-header"
                        //width="90"
                        columnClassName="table-body"
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Start Time
                    </TableHeaderColumn> 

                    <TableHeaderColumn
                        //dataField="end_time"
                        className="table-header"
                        dataFormat={this.endStartTimePicker}
                        //width="90"
                        columnClassName="table-body"
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        End Time
                    </TableHeaderColumn>  

                    <TableHeaderColumn
                        dataFormat={this.renderCheckBox}
                        className="table-header"
                        dataAlign='center'
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209"}}
                        //width="10"
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Next Day
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        className="table-header"
                        dataFormat={this.actionCreator}
                        dataAlign='center'
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Actions
                    </TableHeaderColumn>                  
                
                </BootstrapTable>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        stores: state.stores
    }
}

export default connect(mapStateToProps)(withRouter(CollapsibleRow))


// WEBPACK FOOTER //
// ./src/modules/Stores/Components/CollapsibleRow.js